import { computed } from 'vue';
import store from '@/store';
import { useAuth } from '@/composables/useAuth';
import { getLoginRoute } from '@/router/navigation';
const { isAuthenticated /*, login, logout, switchMerchant, merchants, merchantId, user, error */ } = useAuth();
// console.log('useAuth:isAuthenticated', isAuthenticated.value);

const merchant = computed(() => store.getters.merchant);

export async function checkAuthMiddleware(to, from, next) {
  /* Auth */
  const { isAuthenticated } = useAuth();
  const requiresAuth = to.matched.some((r) => r.meta.requiresAuth);
  const requiresUnauth = to.matched.some((r) => r.meta.requiresUnauth);
  const isSalesCrm = to.matched.some((r) => r.meta.authArea === 'sales-crm');
  const isE2EBypassEnabled = process.env.VUE_APP_E2E_BYPASS_AUTH === 'true';

  if (requiresAuth && isE2EBypassEnabled && !isSalesCrm) {
    store.commit('set_role', 'back-office');
    store.commit('set_merchant', {
      merchantId: 'test-merchant',
      merchantSlugName: 'test-merchant',
      currencySign: {
        currencySign: '₽',
        currencyName: 'Russian Ruble',
        currencyCode: 'RUB',
      },
    });
    store.commit('set_userid', 'test-user-id');
    store.commit('SET_MENUITEM', to.meta.menuItems);
    return next();
  }

  if (requiresAuth && !isAuthenticated.value) {
    next(getLoginRoute(to));

    return;
  } else if (requiresAuth && !merchant.value && !isSalesCrm) {
    await store.dispatch('get_merchant');

    return next();
  } else if (requiresUnauth && isAuthenticated.value) {
    const locale = to.params.locale || localStorage.getItem('locale') || 'ru';
    next({ name: 'main', params: { locale } });

    return;
  }

  store.commit('SET_MENUITEM', to.meta.menuItems);

  next();
}
